export default __webpack_public_path__ + "static/media/screaming.e7d9be43.png";